import { render, staticRenderFns } from "./editNormalRecord.vue?vue&type=template&id=b41455a4&scoped=true&"
import script from "./editNormalRecord.vue?vue&type=script&lang=js&"
export * from "./editNormalRecord.vue?vue&type=script&lang=js&"
import style0 from "./editNormalRecord.vue?vue&type=style&index=0&id=b41455a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41455a4",
  null
  
)

export default component.exports